import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { isDefined } from '../utils/utils';

@Injectable({
	providedIn: 'root'
})
export class TwoFactorGuard implements CanActivate {
	constructor(
		private authStore: AuthStore,
		private router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const hasTwoFactor = isDefined(this.authStore.typeTwoFA());
		
		if (!hasTwoFactor) {
			this.router.navigateByUrl('/send');
			return false;
		}
		
		return true;
	}
}
